import { http } from '@/core/api/';
import { modelToPayload } from './_utils';

export const scheduleOREMeetingApi = {
  create: async ({ requestId, meetingTypeId, model }) => {
    try {
      const payload = modelToPayload(model);
      const { data } = await http.post(`api/tapRequests/meeting`, {
        requestId,
        typeMeetingId: meetingTypeId,
        ...payload,
      });
      return data ?? null;
    } catch {
      return null;
    }
  },

  edit: async ({ requestId, meetingTypeId, id, model }) => {
    try {
      const payload = modelToPayload(model);
      const { data } = await http.put(`api/tapRequests/meeting/${id}`, {
        requestId,
        typeMeetingId: meetingTypeId,
        ...payload,
      });
      return data ?? null;
    } catch {
      return null;
    }
  },

  remove: async (id) => {
    try {
      await http.delete(`api/tapRequests/meeting/${id}`);
      return true;
    } catch {
      return null;
    }
  },
};
